<template>
	<div
		:ref="field"
		:class="cellClass"
		:style="computedColumStyle"
		class="grid-cell"
	>
		<div style="display: block; width: 100%; overflow:hidden;">
			<slot
				:name="field"
				:item="item"
				:value="value"
				:displayValue="displayValue"
			>
				<span :title="displayValue">
					{{ displayValue }}
				</span>
			</slot>
		</div>
	</div>
</template>

<script>
import objGet from './objGet';
export default {
	name: 'TColumn',
	props: {
		item: Object,
		column: Object,
		columnDefinition: Object,
		columnStyle: [ String, Object ],
	},
	computed: {
		computedColumStyle() {
			return { ...this.columnStyle, ...this.columnDefinitionStyle, ...this.columnDefinitionComputedStyle };
		},
		field() {
			return this.column.field;
		},
		displayValue() {
			if (this.columnDefinition) {
				try {
					return this.columnDefinition.displayValueGetter ? this.columnDefinition.displayValueGetter(this.item) : this.value;
				} catch (e) {
					console.error(e);
					console.error(new Error(`Failed to get display value for field ${this.column.field}`), this.item);
					return 'Error';
				}
			} else {
				return '';
			}
		},
		value() {
			if (this.columnDefinition) {
				return this.columnDefinition.valueGetter ? this.columnDefinition.valueGetter(this.item) : objGet(this.item, this.column.field);
			} else {
				return '';
			}
		},
		cellClass() {
			let result = {};
			if (this.columnDefinition) {
				let {
					type,
					cellClassRules,
					cellClass
				} = this.columnDefinition;
				if (type) {
					result[`grid-cell-type-${type}`] = true;
				}

				if (cellClassRules) {
					for (let className in cellClassRules) {
						if (cellClassRules[className] instanceof Function) {
							result[className] = cellClassRules[className](this.item);
						}
					}
				}
				if (cellClass) {
					if (cellClass instanceof Function) {
						let name = cellClass(this.item);
						if (name)
							result[name] = true;
					} else {
						result[cellClass] = true;
					}
				}
			}
			return result;
		},
		columnDefinitionStyle() {
			if (this.columnDefinition) {
				if (this.columnDefinition.cellStyle instanceof Function) {
					return this.columnDefinition.cellStyle(this.item);
				} else {
					return this.columnDefinition.cellStyle;
				}
			} else {
				return undefined;
			}
		},
		columnDefinitionComputedStyle() {
			if (this.columnDefinition) {
				let result = {};
				let { align } = this.columnDefinition;

				if (align) {
					result.textAlign = align;
				}

				return result;
			} else {
				return undefined;
			}
		}
	},
};

</script>
